import React from "react";
var __jsx = React.createElement;
import { FormattedMessage } from 'react-intl';
import { AffiliationWarningContainer, WarningIcon, WarningMessage } from './AffiliationWarning.style';

var AffiliationWarning = function AffiliationWarning(_ref) {
  var messageId = _ref.messageId;
  return __jsx(AffiliationWarningContainer, null, __jsx(WarningIcon, null), __jsx(FormattedMessage, {
    id: messageId,
    tagName: WarningMessage
  }));
};

export default AffiliationWarning;